import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { CommonPacksPage as NewCommonPacksPage } from '@sorare/marketplace/src/components/commonCard/CommonPacksPage';
import { SearchParamBasedBuyGemsDialog } from '@sorare/marketplace/src/components/commonCard/SearchParamBasedBuyGemsDialog';

import type { CommonPacks_marketRoot } from './__generated__/index.graphql';

const Wrapper = styled(Vertical).attrs({ gap: 6 })`
  padding-bottom: var(--double-unit);
  container-type: inline-size;
`;

type Props = {
  marketRoot: CommonPacks_marketRoot;
  refetch: () => Promise<unknown>;
};

export const CommonPacks = ({ marketRoot, refetch }: Props) => {
  return (
    <>
      <Wrapper>
        <FullWidthContainer.NoPadding>
          <NewCommonPacksPage refetch={refetch} marketRoot={marketRoot} />
        </FullWidthContainer.NoPadding>
      </Wrapper>
      <SearchParamBasedBuyGemsDialog />
    </>
  );
};

CommonPacks.fragments = {
  marketRoot: gql`
    fragment CommonPacks_marketRoot on MarketRoot {
      id
      ...CommonPacksPage_marketRoot
    }
    ${NewCommonPacksPage.fragments.marketRoot}
  ` as TypedDocumentNode<CommonPacks_marketRoot>,
};
